import React from 'react';

import { Row, Rows, Span, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

export const TextDemo = () => {
  return (
    <Rows>
      <Row style={{ backgroundColor: publicaColors.lightGray }}>
        <Text subheader>Text</Text>
        <Text small muted>
          Make sure to import this from{' '}
          <Span highlighted bold>
            publicaUI
          </Span>
        </Text>
      </Row>
      <Row noVerticalPadding>
        <Text header>Header</Text>
      </Row>
      <Row noVerticalPadding>
        <Text subheader>Subheader</Text>
      </Row>
      <Row noVerticalPadding>
        <Text title>Title</Text>
      </Row>
      <Row noVerticalPadding>
        <Text mini>Mini</Text>
      </Row>
      <Row noVerticalPadding>
        <Text extraSmall>ExtraSmall</Text>
      </Row>
      <Row noVerticalPadding>
        <Text small>Small</Text>
      </Row>
      <Row noVerticalPadding>
        <Text baseSize>BaseSize</Text>
      </Row>
      <Row noVerticalPadding>
        <Text large>Large</Text>
      </Row>
      <Row noVerticalPadding>
        <Text extraLarge>ExtraLarge</Text>
      </Row>
      <Row noVerticalPadding>
        <Text muted>Muted</Text>
      </Row>
      <Row noVerticalPadding>
        <Text highlighted>Highlighted</Text>
      </Row>
      <Row noVerticalPadding>
        <Text bold>Bold</Text>
      </Row>
      <Row noVerticalPadding>
        <Text heavy>Heavy</Text>
      </Row>
      <Row noVerticalPadding>
        <Text color={publicaColors.red}>
          Color Prop <Span italic>(color = publicaColors.red)</Span>
        </Text>
      </Row>
      <Row height={16}></Row>
    </Rows>
  );
};
